import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const business = (domain, resource, withAuth = true) => {
    const url = `${domain}/${resource}`;
    const getHeaders = () => withAuth ? Authorization() : {};

    return {
        getDashboard: () => executeCall(() => Axios.get(`${url}/dashboard`, { headers: getHeaders() })),
        
        getEmployees: (params) => executeCall(() => Axios.get(`${url}/employees`, { params, headers: getHeaders() })),
        
        addEmployee: (data) => executeCall(() => Axios.post(`${url}/employees`, data, { headers: getHeaders() })),
        
        deleteEmployee: (id) => executeCall(() => Axios.delete(`${url}/employees/${id}`, { headers: getHeaders() })),
        
        deleteEmployeesBulk: (employeeIds) => executeCall(() =>
            Axios.delete(`${url}/employees/bulk`, {
                data: { employeeIds },
                headers: getHeaders(),
            })
        ),
        
        assignSessions: (id, data) => executeCall(() => 
            Axios.post(`${url}/employees/${id}/assign`, data, { headers: getHeaders() })
        ),

        assignSessionsBulk: (employeeIds, sessions) => executeCall(() =>
            Axios.post(`${url}/employees/assign-bulk`, { employeeIds, sessions }, { headers: getHeaders() })
        ),
        
        getTokenHistory: () => executeCall(() => Axios.get(`${url}/tokens`, { headers: getHeaders() })),
        
        purchaseTokens: (data) => executeCall(() => 
            Axios.post(`${url}/tokens/purchase`, data, { headers: getHeaders() })
        ),

        getTokenPackages: () => executeCall(() =>
            Axios.get(`${url}/tokens/packages`, { headers: getHeaders() })
        ),
        
        getWellnessSummary: (params) => executeCall(() =>
            Axios.get(`${url}/dashboard/wellness-summary`, { params, headers: getHeaders() })
        ),

        exportNOM035: (params) => executeCall(() => 
            Axios.get(`${url}/reports/nom035`, { 
                params, 
                headers: getHeaders(),
                responseType: 'blob' 
            })
        ),

        exportEmployees: () => executeCall(() =>
            Axios.get(`${url}/employees/export`, {
                headers: getHeaders(),
                responseType: 'blob',
            })
        ),

        getEmployeesTemplate: () => executeCall(() =>
            Axios.get(`${url}/employees/template`, {
                headers: getHeaders(),
                responseType: 'blob',
            })
        ),

        importEmployees: (file) => {
            const formData = new FormData();
            formData.append('file', file);
            return executeCall(() =>
                Axios.post(`${url}/employees/import`, formData, {
                    headers: { ...getHeaders(), 'Content-Type': 'multipart/form-data' },
                })
            );
        },

        getProfile: () => executeCall(() =>
            Axios.get(`${url}/profile`, { headers: getHeaders() })
        ),

        updateProfile: (data) => executeCall(() =>
            Axios.patch(`${url}/profile`, data, { headers: getHeaders() })
        ),
    };
};

export default business;
